import styled from 'styled-components';
import SbTag from 'uiCore/SbTag/SbTag';


export const PageWrapperStyled = styled.div`
  padding: 32px 40px 0;
  background: ${p => p.theme?.colors?.light ?? '#F7F7F7'};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;


export const DragIconStyled = styled.span`
  color: ${p => p.theme?.colors?.tertiary ?? '#8790A4'};
  cursor: grab;
  display: flex;
  align-items: center;
`;

export const SectionTagStyled = styled(SbTag)`
  border-radius: 4px !important;
  border: none !important;
  background: ${p =>
    p.$required
      ? (p.theme?.colors?.successBg ?? '#F5FBF8')
      : (p.theme?.colors?.light ?? '#F7F7F7')
  } !important;
  color: ${p =>
    p.$required
      ? (p.theme?.colors?.primary ?? '#008080')
      : (p.theme?.colors?.textLight ?? '#9CA3AF')
  } !important;
`;


export const EditorGridStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: ${p => p.theme?.colors?.white ?? '#ffffff'};
  border-radius: 10px;
  border: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  overflow: hidden;
  min-height: 500px;
`;

export const EditorPanelStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &:first-child {
    border-right: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  }
`;

export const EditorPanelHeaderStyled = styled.div`
  padding: 10px 16px;
  border-bottom: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  color: ${p => p.theme?.colors?.primary ?? '#008080'};
  letter-spacing: 0.06em;
  display: flex;
  align-items: center;
  gap: 6px;
`;


export const FooterRowStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  background: ${p => p.theme?.colors?.light ?? '#F7F7F7'};
  padding: 16px 0;
  z-index: 10;
`;
